import { GOOGLE_ANALYTICS_ID } from "@/config/constants";

export const pageview = (url: string) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag('config', GOOGLE_ANALYTICS_ID, {
      page_path: url,
    });
  }
};

export const event = ({ action, params }: { action: string; params: Record<string, any> }) => {
  action = `iceridge-${action}`
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag('event', action, params);
  }
};